import React, { createContext, ReactNode, useContext, useState } from 'react';
import OtpModal from '../components/otpModal/OtpModal';

interface IComponentProps {
  children: ReactNode;
}

const OtpModalProvider: React.FC<IComponentProps> = function ({ children }) {
  /*
   ** State can be exposed through the private API
   */
  const [showModal, setShowModal] = useState<boolean>(false);
  const [handleDismiss, setHandleDismiss] = useState<() => void | undefined>();

  /*
   ** This method can be exposed through the private API but can only contain
   ** react specific code
   */
  const showOtpModal = (handleDismiss?: () => void) => {
    setShowModal(true);
    setHandleDismiss(() => handleDismiss);
  };

  const hideOtpModal = () => {
    setShowModal(false);
  };

  return (
    <OtpModalContext.Provider
      value={{
        state: {},
        actions: {
          showOtpModal,
          hideOtpModal,
        },
      }}>
      {children}
      <OtpModal
        showModal={showModal}
        handleDismiss={() => {
          setShowModal(false);
          handleDismiss && handleDismiss();
        }}
      />
    </OtpModalContext.Provider>
  );
};

export const otpModalProvider = {
  state: {} as {},
  actions: {} as {
    showOtpModal: (handleDismiss?: () => void) => void;
    hideOtpModal: () => void;
  },
};

/*
 ** NOTE:
 ** To use this in react components, use the following code example:
 ** const { state: {showOtpModal}, actions: { privateMethod, setShowOtpModal }} = useOtpModal();
 **
 ** To use this in non-react components, use the following code example:
 ** useOtpModalStatic.publicMethod();
 */

export const OtpModalContext = createContext<typeof otpModalProvider>(otpModalProvider);
export const useOtpModal = () => useContext(OtpModalContext);

// Expose methods for use in non-react components
export const otpModalStatic = {};

export default OtpModalProvider;
